import {
  GET_DEFAULT_REGION_ERROR,
  GET_DEFAULT_REGION_REQUEST,
  GET_DEFAULT_REGION_SUCCESS,


} from "./types.js";
import { BASEURL } from "../../constant/config.js";

const axios = require("axios");

export const getDefaultRegion = (token) => (dispatch) => {
  dispatch({ type: GET_DEFAULT_REGION_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/DefaultUserRegion`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
  })
    .then((response) => {
      return dispatch({
        type: GET_DEFAULT_REGION_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      return dispatch({
        type: GET_DEFAULT_REGION_ERROR,
        payload: error.response,
      });
    });
};

